const WaitingListOverview = (() => {
  let selectedRow, selectedRowId;
  // UI Instances
  let selectedConsumer;
  let overviewWrap;
  let wlReviewTable;
  let deleteWarningPopup;
  let withdrawReasonPopup;
  let _wlSpinner = null;   

  // DATA
  //--------------------------------------------------
  async function getReviewDataByConsumer(consumerId) {
    const data = await _UTIL.fetchData('getLandingPageForConsumer', {
      consumerId,
    });

    const response = await _UTIL.fetchData('getConsumerSalesforceId', { peopleId: selectedConsumer.id });
    SFAccountId = response.GetConsumerSalesforceIdResult;

    // string wlInfoId
    // string interviewDate
    // string conclusionResult
    // string conclusionDate
    // string sentToDODD

    const conclusionResults = {
      0: 'No qualifying condition',
      1: 'Immediate Need',
      2: 'Current Need',
      3: 'Neither Immediate Need nor Current Need',
    };

    let alreadyHasAssessmentForToday = false;

    const tableData = data.getLandingPageForConsumerResult
      .map(({ wlInfoId, interviewDate, conclusionResult, conclusionDate, sentToDODD, salesforceID, assessmentStatus, reasonForDisapproval, conclusionResultString  }) => {
        const isToday = new Date().setHours(0, 0, 0, 0) === new Date(interviewDate).setHours(0, 0, 0, 0);
        if (isToday) alreadyHasAssessmentForToday = true;

        // if salesforceID is neither null, undefined, nor empty, append 'API'
      const id =
          SFAccountId != null && SFAccountId !== ""
            ? `${wlInfoId}API`
            : wlInfoId;

          const conclusionResultFormatted = (salesforceID != null && salesforceID !== "")
          ? (
              !conclusionResultString
                ? 'No qualifying condition'
                : (reasonForDisapproval == null || reasonForDisapproval === '')
                  ? conclusionResultString
                  : `${conclusionResultString} - ${reasonForDisapproval}`
            )
          : conclusionResults[conclusionResult];

        return {
          id,
          values: [
            UTIL.formatDateToIso(interviewDate.split(' ')[0]),
            conclusionResultFormatted,
            UTIL.formatDateToIso(conclusionDate.split(' ')[0]),
            UTIL.formatDateToIso(sentToDODD.split(' ')[0]),
            assessmentStatus
          ],
        };
      })
      .sort((a, b) => {
        const dateA = new Date(a.values[0]).getTime();
        const dateB = new Date(b.values[0]).getTime();

        if (dateA > dateB) {
          return -1;
        } else if (dateA < dateB) {
          return 1;
        } else {
          return 0;
        }
      });

    return { tableData, alreadyHasAssessmentForToday };
  }

  // EVENTS
  //--------------------------------------------------
  async function populateReviewTable() {
    wlReviewTable.clear();

    if (!selectedConsumer) {
      newAssessmentBtn.toggleDisabled(true);
      return;
    };

    const { tableData, alreadyHasAssessmentForToday } = await getReviewDataByConsumer(selectedConsumer.id);
    wlReviewTable.populate(tableData);

    const rows = document.querySelectorAll('.colSort tbody tr');
    rows.forEach(row => {
      const statusCell = row.querySelector('td:nth-child(5)');
      const deleteCell = row.querySelector('td[data-type="deleteRow"]');
      if (statusCell && deleteCell && statusCell.textContent.trim() !== 'Draft') {
        deleteCell.style.display = 'none';
      }
    });

    const isNewAssessmentBtnDisabled = alreadyHasAssessmentForToday || !$.session.waitingListInsert;
    newAssessmentBtn.toggleDisabled(isNewAssessmentBtnDisabled);
  }
  function attachEvents() {
    newAssessmentBtn.onClick(() => {
      NewWaitingListAssessment.init({ selectedConsumer, moduleHeader, moduleBody, isNewAssessment: true }, true);
    });

    rosterPicker.onConsumerSelect(
      data => {
        selectedConsumer = Object.values(data)[0];
        populateReviewTable();
      },
      { idkyet: true },
    );

    wlReviewTable.onRowClick(async rowId => {
      if (!$.session.waitingListView) return;

      const isAPI = rowId.endsWith('API');
      const rawId = isAPI 
        ? rowId.slice(0, -3)    // remove the "API" suffix
        : rowId;
      
      let resp;

      if (isAPI) {
        const resp = await _UTIL.fetchData('getWaitingListAssessmentWithAPIData', { waitingListAssessmentId: parseInt(rawId) });

        NewWaitingListAssessment.init({
          wlData: resp.getWaitingListAssessmentWithAPIDataResult,
          selectedConsumer: selectedConsumer,
          moduleHeader,
          moduleBody,
          isNewAssessment: false,
          WLInfoID: rawId
        });
      } else {
        resp = await _UTIL.fetchData('getWaitingListAssessment', { waitingListAssessmentId: parseInt(rawId) });

        WaitingListAssessment.init({
          wlData: resp.getWaitingListAssessmentResult[0],
          selectedConsumer: selectedConsumer,
          moduleHeader,
          moduleBody,
        });
      }
    });
    wlReviewTable.onRowDelete(async (row, rowId) => {
      selectedRow = row;
      selectedRowId = rowId;

      deleteWarningPopup.show();
    });
  }

  // MAIN
  //--------------------------------------------------
  function populateDeleteWarningPopup() {
    const messageEle = _DOM.createElement('p', {
        class: 'confirmation__message',
        text: 'Are you sure you want to delete this assessment?'
    });

    const btnWrap = _DOM.createElement('div', { class: 'button-wrap' });
    const confirmButton = new Button({
        text: 'Yes',
        name: 'confirm',
        //icon: 'checkmark', 
    });
    const cancelButton = new Button({
        text: 'No',
        name: 'cancel',
        //icon: 'close',
    });    

    confirmButton.onClick(async () => {
      const isAPI = selectedRowId.endsWith('API');
    
      if (isAPI) {
        // Instead of immediately calling WLAWithdrawAssessmentFromAPI,
        // we pop up our “withdrawReasonPopup” so the user can pick one checkbox.
        populateWithdrawReasonPopup();
        withdrawReasonPopup.renderTo(_DOM.ACTIONCENTER);
        withdrawReasonPopup.show();
        return;
      }
    
      // If not API, we simply delete as before:
      await _UTIL.fetchData('deleteWaitingListAssessment', {
        waitingListId: parseInt(selectedRowId, 10),
      });
      wlReviewTable.removeRow(selectedRow);
      deleteWarningPopup.close();
      selectedRow = null;
      selectedRowId = null;
    });
    
    cancelButton.onClick(() => {
      deleteWarningPopup.close();
    });

    confirmButton.renderTo(btnWrap);
    cancelButton.renderTo(btnWrap);

    deleteWarningPopup.dialog.appendChild(messageEle);
    deleteWarningPopup.dialog.appendChild(btnWrap);
  }
  async function loadPage() {
    await rosterPicker.fetchConsumers();
    rosterPicker.populate();

    deleteWarningPopup.renderTo(_DOM.ACTIONCENTER);
    populateDeleteWarningPopup();

    withdrawReasonPopup.renderTo(_DOM.ACTIONCENTER);
  }
  function loadPageSkeleton() {
    moduleBody.innerHTML = '';
    moduleHeader.innerHTML = '';

    overviewWrap = _DOM.createElement('div', { class: 'waitingListOverview' });

    moduleBody.appendChild(overviewWrap);

    wlReviewTable.renderTo(overviewWrap);
    rosterPicker.renderTo(overviewWrap);
    newAssessmentBtn.renderTo(moduleHeader);
  }

function populateWithdrawReasonPopup() {
  // Clear any previous contents
  withdrawReasonPopup.clear();

  // 1) Add a title/message at the top
  const titleEle = _DOM.createElement('p', {
    class: 'confirmation__message',
    text: 'Select exactly one reason for withdrawing this assessment:'
  });
  withdrawReasonPopup.dialog.appendChild(titleEle);

  // 2) Create a container for our Checkbox list
  const checkboxContainer = _DOM.createElement('div', { class: 'checkbox-list' });
  withdrawReasonPopup.dialog.appendChild(checkboxContainer);

  function showSpinner(message) {
    // Tear down any existing spinner
    if (_wlSpinner) {
      _wlSpinner.removeElement();
      _wlSpinner = null;
    }

    // 1) Build a container
    const wrapper = document.createElement('div');
    wrapper.classList.add('pendingSavePopup', 'popup');

    // 2) Optionally, add a message
    const msgElem = document.createElement('h2');
    msgElem.classList.add('spinner__message');
    msgElem.textContent = message || 'Loading…';

    msgElem.style.setProperty('display', 'block', 'important');

    // 3) Instantiate the new Spinner and attach
    _wlSpinner = new Spinner({
      /* you can pass size/speed overrides */
    });
    wrapper.appendChild(_wlSpinner.spinnerWrap);

    // 4) Append message + spinner into your ACTIONCENTER
    overlay.show();
    DOM.ACTIONCENTER.appendChild(wrapper);
    wrapper.appendChild(msgElem);
  }

  function hideSpinner() {
    // Remove the popup wrapper, hide overlay
    const popup = document.querySelector('.pendingSavePopup');
    if (popup) {
      popup.remove();
      overlay.hide();
    }
    // Clean up internal instance
    if (_wlSpinner) {
      _wlSpinner.removeElement();
      _wlSpinner = null;
    }
  }

  const APOS = "\u2019";

  // 3) Define your eight options (value/text). Adjust labels as needed:
  const reasons = [
    {
      id:    "failure_to_respond_to_attempts_by_county_board",
      label: "Failure to respond to attempts by the county board to contact the individual or the individual" + APOS + "s guardian",
      value: "Failure to respond to attempts by the county board to contact the individual or the individual" + APOS + "s guardian"
    },
    {
      id:    "determined_no_longer_to_have_a_need",
      label: "Determined no longer to have a need",
      value: "Determined no longer to have a need"
    },
    {
      id:    "request_from_individuals_guardian",
      label: "Request from the individual or the individuals guardian",
      value: "Request from the individual or the individuals guardian"
    },
    {
      id:    "no_longer_has_condition_described_in_rule",
      label: "No longer has a condition described in rule",
      value: "No longer has a condition described in rule"
    },
    {
      id:    "no_longer_resident_of_ohio",
      label: "No longer resident of Ohio",
      value: "No longer resident of Ohio"
    },
    {
      id:    "refuses_to_secure_medicaid",
      label: "Refuses to secure Medicaid",
      value: "Refuses to secure Medicaid"
    },
    {
      id:    "deceased",
      label: "Deceased",
      value: "Deceased"
    },
    {
      id:    "refuses_or_withdraws_consent_for_ssa",
      label: "Refuses or withdraws consent for service and support administration",
      value: "Refuses or withdraws consent for service and support administration"
    }
  ];
  

  // We'll keep references so we can enforce "only one checked at a time"
  const checkboxInstances = [];

  // 4) Instantiate a Checkbox for each reason
  reasons.forEach(({ id, label }) => {
    const cb = new Checkbox({
      id,
      label,
      required: true,
      note: null
    });
    // Append it into the container
    cb.renderTo(checkboxContainer);
    checkboxInstances.push(cb);
  });

  // 5) Whenever any checkbox is toggled, uncheck all others
  checkboxInstances.forEach((cbInstance) => {
    cbInstance.onChange(() => {
      if (cbInstance.getValue()) {
        // If this one was checked, uncheck all the rest:
        checkboxInstances.forEach((otherCb) => {
          if (otherCb !== cbInstance) {
            otherCb.clear();
          }
        });
      }
    });
  });

  // 6) Create the Submit + Cancel buttons
  const btnWrap = _DOM.createElement('div', { class: 'button-wrap' });
  const submitBtn = new Button({
    text: 'Submit',
    name: 'submitReason',
    style: 'primary',
    styleType: 'contained'
  });
  const cancelBtn = new Button({
    text: 'Cancel',
    name: 'cancelReason',
    style: 'secondary',
    styleType: 'contained'
  });

  // 7) Hook up Cancel to simply close this popup
  cancelBtn.onClick(() => {
    withdrawReasonPopup.close();
  });

  // 8) Hook up Submit:
  submitBtn.onClick(async () => {
    // 1) show the spinner
    showSpinner('Deleteing Assessment...');

    // d) Close both popups
    withdrawReasonPopup.close();
    deleteWarningPopup.close();
  
    try {
      // a) Find which checkbox is checked
      const chosen = checkboxInstances.find(cbInst => cbInst.getValue());
      if (!chosen) {
        alert('Please select exactly one reason before submitting.');
        return;
      }
      const reasonText = chosen.rootElement.querySelector("label").innerText;
  
      // b) Call the withdraw API now that the user has selected a reason
      const rawId = selectedRowId.endsWith('API')
        ? selectedRowId.slice(0, -3)
        : selectedRowId;
      const resp = await _UTIL.fetchData('WLAWithdrawAssessmentFromAPI', {
        rowId: rawId,
        reasonText: reasonText
      });
      const success = resp.WLAWithdrawAssessmentFromAPIResult;
      if (success !== 'Success') {
        alert('Withdrawal failed on the server. Please try again.');
        return;
      }
  
      // c) After successful withdrawal, proceed to actually delete the row:
      await _UTIL.fetchData('deleteWaitingListAssessment', {
        waitingListId: parseInt(selectedRowId, 10)
      });
      wlReviewTable.removeRow(selectedRow);
  
      // e) Clear selection
      selectedRow = null;
      selectedRowId = null;
    } finally {
      // 3) always hide the spinner
      hideSpinner();
    }
  });
  

  // 9) Render the buttons into the popup
  submitBtn.renderTo(btnWrap);
  cancelBtn.renderTo(btnWrap);
  withdrawReasonPopup.dialog.appendChild(btnWrap);
}
  // INIT (data & defaults)
  //--------------------------------------------------
  function initComponents() {
    wlReviewTable = new Table({
      columnSortable: true,
      allowDelete: $.session.waitingListDelete,
      headings: [
        {
          text: 'Interview Date',
          type: 'date',
        },
        {
          text: 'Conclusion',
          type: 'string',
        },
        {
          text: 'Conclusion Date',
          type: 'date',
        },
        {
          text: 'Sent To DODD',
          type: 'date',
        },
        {
          text: 'DODD Status',
          type: 'string',
        },
      ],
    });

    rosterPicker = new RosterPicker({
      allowMultiSelect: false,
      consumerRequired: true,
    });

    newAssessmentBtn = new Button({
      text: 'New Assessment',
      style: 'primary',
      styleType: 'contained',
      disabled: true,
    });

    deleteWarningPopup = new Dialog({ className: 'wlDeleteWarningPopup' });

    withdrawReasonPopup = new Dialog({ className: 'wlWithdrawReasonPopup' });
  }
  async function reload() {
    loadPageSkeleton();
    await loadPage();
    attachEvents();
  }
  async function init(opts) {
    moduleHeader = opts.moduleHeader;
    moduleBody = opts.moduleBody;
    selectedConsumer = opts.selectedConsumer;

    initComponents();
    loadPageSkeleton();
    await loadPage();
    attachEvents();

    if (selectedConsumer) {
      populateReviewTable();
      rosterPicker.setSelectedConsumers([selectedConsumer.id]);
    }
  }

  return {
    init,
    reload,
  };
})();
